<template>
    <b-container fluid class="landing">
        <section-points :content="SectionPoints"/>
        <!-- <transition
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutLeft">
            >
            <section-solutions v-if="show" :content="sectionSolutions"/>
        </transition> -->
        <transition
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutLeft">
            >
            <section-presentation v-if="show" :content="SectionPresentation"/>
        </transition>
        <transition
                enter-active-class="animated slideInUp"
                leave-active-class="animated slideOutLeft">
            >
            <section-associate id="socios" v-if="show && SectionAssociate.socios" :content="SectionAssociate"/>
        </transition>
    </b-container>
</template>
<script>
    import SectionPoints from '@/components/landing/section-points'
    // import SectionSolutions from '@/components/landing/section-solutions'
    import SectionAssociate from '@/components/landing/section-associate'
    import SectionPresentation from '@/components/landing/section-presentation'
    import EventBus from '@/bus/index'

    export default {
        name: 'Landing',
        components: {
            // SectionSolutions,
            SectionAssociate,
            SectionPresentation,
            SectionPoints
        },
        data: () => ({
            show: true,
            SectionPoints: {
                titulo: 'Puntos <br><span>que</span> <strong>sí</strong> <span>suman</span> ',
                bloque1: {
                    titulo: 'Soy <br><span>Cliente</span>',
                    content: '<span>Acumula puntos, canjéalos por productos</span> y disfruta de un mundo de beneficios exclusivos.',
                    texto_boton: 'Quiero saber más'
                },
                bloque2: {
                    titulo: 'Soy <br><span>Negocio</span>',
                    content: 'Te brindamos <span>la mejor asesoría y estrategia</span> para fidelizar a tus clientes.<span>',
                    texto_boton: 'Quiero saber más'
                }
            },
             SectionPresentation: {
                titulo: '¿Qué es <strong> GOX  </strong> ? ',
                subtitulo: 'Puntos que <strong>sí</strong> suman',
                button: 'Ver video completo',
                
            },
            SectionAssociate: {
                titulo: 'Conoce a nuestros <br> socios <strong>GOX</strong>',
                subtitulo: 'Nuestro programa crea y potencia relaciones extraordinarias con sus clientes.',
                button: 'Quiero saber más',
                socios: null,
            }
        }),
        created: function () {
            EventBus.$on('show-panel', (show) => {
                this.show = show
            });
            
        },
        mounted: function() {
            this.getActualParam()
            this.getBusiness()
        },
        methods: {
            getBusiness() {
                this.$store.dispatch('getBusiness').then((response) => {
                    this.SectionAssociate.socios = response.data
                })
            },
            getActualParam () {
                let hash = this.$route.hash
                if(hash) {
                    this.scrollInto('socios')
                }
            },
            scrollInto(elementId) {
                setTimeout(() => {
                    const section = document.querySelector(`#${elementId}`);
                    section.scrollIntoView({
                        behavior: 'smooth'
                    });
                }, 1000)
                
                
            }
        }
    }
</script>
<style scoped>
</style>